import { useQuery } from "@tanstack/react-query";
import { viaCepService } from "@/lib/api/via-cep";
import { validateCEP } from "@/lib/custom-validations";
import { AddressViaCepData } from "@/types/address-via-cep";

interface UseViaCepProps {
  zipCode: string;
  enabled?: boolean;
}

export const useViaCep = ({ zipCode, enabled = true }: UseViaCepProps) => {
  const cleanZipCode = zipCode.replace(/\D/g, "");
  const isValidCep = validateCEP(cleanZipCode);

  return useQuery<AddressViaCepData, Error>({
    queryKey: ["viaCep", cleanZipCode],
    queryFn: () => viaCepService.getAddress(cleanZipCode),
    enabled: enabled && isValidCep && cleanZipCode.length === 8,
    staleTime: 1000 * 60 * 30, // 30 minutos - endereços não mudam frequentemente
    gcTime: 1000 * 60 * 60, // 1 hora
    retry: 1,
    refetchOnWindowFocus: false,
  });
};